import React from 'react';
import { BowlingStats } from './types';

const BowlingStatsComponent: React.FC<{ stats: BowlingStats[] }> = ({
  stats
}) => {
  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Bowling Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Arm</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.arm}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Sessions</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.sessions.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.averageScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.maxScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Throws</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.throws.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Distance</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgForwardDistance || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Swing Time</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.avgSwingTime || 0).toLocaleString()}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { BowlingStatsComponent };
